__webpack_require__.p = "/MAM-Les-Fripouilles/";